export const SET_SIGNBOOK = 'SET_SIGNBOOK';
export const SET_SIGNWORKFLOWS = 'SET_SIGNWORKFLOWS';
export const RESET_SIGNWORKFLOWS = 'RESET_SIGNWORKFLOWS';
export const SET_SIGNWORKFLOWS_SEARCH_PARAMS = 'SET_SIGNWORKFLOWS_SEARCH_PARAMS';



// WEBPACK FOOTER //
// ./src/store/modules/parapheurs/types.js